import React, { ReactElement } from 'react'
import { AppId } from 'src/app/AppId'
import { LandingPage } from 'src/ui/layout-page/landing/LandingPage'

export const LandingPageSm = (): ReactElement => {
  return <LandingPage app={AppId.SERVICE_MASTER} />
}
